<!-- version 2021/06/14 -->
<template>
  <a href="" class="btn">
    <i v-if="checked" class="fa fa-lg fa-check-square checked"></i>
    <i v-else class="fa fa-lg fa-check-square "></i>
    {{ title }}
  </a>
</template>

<script>
export default {
  props: {
    title: String,
    checked: Boolean,
  },
};
</script>

<style lang="sass" scoped>
a
  border-radius: 6px !important
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important
  background-color: #FFF !important
  color: #28c3cd !important
  display: flex
  justify-content: center
  align-items: center
i
  font-size: 24px
  margin-right: 10px
  color: rgba(0, 0, 0, 0.08)
  &.checked
    color: rgb(40, 195, 205)
</style>
